module.exports = __webpack_public_path__ + "img/gblue.005a3168.png";